// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch, {
  type Client,
  type RequestConfig,
  type ResponseErrorConfig,
} from "../../apiClient.ts";
import type {
  GetShortCode400,
  GetShortCode401,
  GetShortCode403,
  GetShortCode404,
  GetShortCode405,
  GetShortCode500,
  GetShortCodePathParams,
  GetShortCodeQueryResponse,
} from "../models/GetShortCode.ts";

function getGetShortCodeUrl({
  code,
}: {
  code: GetShortCodePathParams["code"];
}) {
  const res = { method: "GET", url: `/short-codes/${code}` as const };
  return res;
}

/**
 * @description Returns the entry point context data associated with a short code.
 * @summary Resolve a short code
 * {@link /short-codes/:code}
 */
export async function getShortCode(
  { code }: { code: GetShortCodePathParams["code"] },
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetShortCodeQueryResponse,
    ResponseErrorConfig<
      | GetShortCode400
      | GetShortCode401
      | GetShortCode403
      | GetShortCode404
      | GetShortCode405
      | GetShortCode500
    >,
    unknown
  >({
    method: "GET",
    url: getGetShortCodeUrl({ code }).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
